import React from 'react';

import { toast } from 'ravenjs/lib/Toaster';

import CaseEditedToast from 'components/CaseEditedToast';
import { COLOR_TOKENS } from 'constants/quartz';

const CASE_EDITED_TOAST_DURATION = 10000;

const CASE_EDITED_TOAST_STYLE = {
    background: COLOR_TOKENS.feedback.info.background,
    color: COLOR_TOKENS.feedback.info.text,
    borderLeft: `4px solid ${COLOR_TOKENS.feedback.info.border}`,
};

function displayCaseEditedToast(editorName, field) {
    toast.info(
        <CaseEditedToast
            editorName={editorName || 'Someone'}
            field={field || 'details'}
            onReload={() => window.location.reload()}
        />,
        {
            autoClose: CASE_EDITED_TOAST_DURATION,
            style: CASE_EDITED_TOAST_STYLE,
            pauseOnHover: true,
            pauseOnFocusLoss: true,
        }
    );
}

const heldBackToasts = [];

function showHeldBackToasts() {
    window.removeEventListener('focus', showHeldBackToasts);

    while (heldBackToasts.length > 0) {
        const { editorName, field } = heldBackToasts.shift();

        displayCaseEditedToast(editorName, field);
    }
}

/**
 * Show the case edited toast, giving the advisor the full auto-close duration to read it.
 *
 * While the window is focused the toast is shown right away and react-toastify pauses its
 * timer for as long as the window stays blurred. When the window is already blurred the
 * toast is held back until the advisor returns, so its timer starts from the full duration.
 *
 * @method showCaseEditedToast
 * @param  {string} editorName Display name of the user who edited the case
 * @param  {string} field      Category of the case that was edited
 * @return {void}
 */
export function showCaseEditedToast(editorName = 'Someone', field = 'details') {
    if (typeof document !== 'undefined' && document.hasFocus && !document.hasFocus()) {
        if (heldBackToasts.length === 0) {
            window.addEventListener('focus', showHeldBackToasts);
        }

        heldBackToasts.push({ editorName, field });
        return;
    }

    displayCaseEditedToast(editorName, field);
}
